import React, { useState, useEffect } from "react";
import Feedback from "./Feedback";
import {
  Button,
  GreenButton,
  RedButton
} from "../../../globals/components/button";
import styled from "styled-components";
import background from "../assets/background.png";
import trophy from "../assets/trophy.png";


export default function GameResult({ ...props }) {

  function GetAmount(){
    return (props.correct.length+props.incorrect.length).toString();
  }

  const [showFeedback, setShowFeedback] = useState(false);
  const {
    feedback,
    questionFontSize,
    score,
    correct,
    incorrect,
    onRestartGame,
    onBack,
    quitGame
  } = props;

  let resultText = "";
  let rating = "";

  console.log(props);

  return (
    <ApplicationResult>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between"
        }}
      >
        <ResultImage>
          <div style={{ position: "relative", height: "300px" }}>
            <Banner>Well Done!</Banner>
          </div>
        </ResultImage>
        {showFeedback ? (
          <ResultText style={{ maxHeight: "500px", overflowY: "scroll" }}>
            Feedback
            <Feedback feedback={feedback} questionFontSize={questionFontSize} />
          </ResultText>
        ) : (
          <ResultText style={{ maxHeight: "500px", overflowY: "scroll" }}>
            <span>{resultText}</span>
            <ResultScores>
              <Result>
                <div>Score:</div>
                <ResultValue>{correct.length}/{GetAmount()}</ResultValue>
              </Result>
            </ResultScores>
            {props.isRating && (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexDirection: "column",
                  border: "solid #e4e4e4 2px",
                  marginTop: "20px"
                }}
              >
                <span style={{ fontSize: "0.6em" }}>Rating</span>
                <div style={{ fontSize: "1.2em" }}>{rating}</div>
              </div>
            )}
          </ResultText>
        )}
      </div>
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <RedButton
        style={{
          width: "40%",
          height: "60px",
          fontSize: "30px",
          margin: "20px"
        }}
        onClick={quitGame}>
          Quit
        </RedButton>
        {feedback.length > 0 && (
          <GreenButton
            onClick={() => setShowFeedback(!showFeedback)}
            style={{
              width: "40%",
              height: "60px",
              fontSize: "30px",
              margin: "20px"
            }}
          >
            {showFeedback ? "Hide Feedback" : "Show Feedback"}
          </GreenButton>
        )}
      </div>
    </ApplicationResult>
  );
}

const ApplicationResult = styled.div`
  height: 100%;
  z-index: 10;
  background: #fff;
  background-image: url(${background});
  padding: 40px;
  font-size: 3em;
  border: solid 2px #683d8c;
  display: flex;
  flex-direction: column;
  justify-content: start;
`;

const ResultScores = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 30px;
  flex-direction: column;
`;

const Result = styled.div`
  display: flex;
  margin-top: 20px;
`;
const ResultValue = styled.div`
  margin: 0px 20px;
  border: solid #e4e4e4 2px;
  background: #fff;
  padding: 0px 15px;
`;

const ResultText = styled.div`
  background: #fff;
  border: solid #683d8c 2px;
  width: 50%;
  border-radius: 10px;
  padding: 10px;
  color: #683d8c;
  font-weight: 600;
  font-size: 1.2em;
`;

const ResultImage = styled.div`
  width: 40%;
  background-image: url(${trophy});
  background-size: auto;
  background-repeat: no-repeat;
  background-position: top;
  display: flex;
  flex-direction: column;
  align-self: center;
`;

const Banner = styled.div`
  position: absolute;
  left: 50%;
  display: block;
  margin: 100px -200px;
  width: 400px;
  height: 60px;
  border: 1px solid #e88f12;
  font: normal 30px/60px;
  line-height: 60px;
  font-weight: 600;
  text-align: center;
  color: #fff;
  background: rgba(255, 186, 32, 1);
  border-radius: 4px;
  box-shadow: 0 0 30px rgba(0, 0, 0, 0.15) inset, 0 6px 10px rgba(0, 0, 0, 0.15);
  &::before,
  ::after {
    content: "";
    position: absolute;
    z-index: -1;
    left: -70px;
    top: 24px;
    display: block;
    width: 40px;
    height: 0px;
    border: 30px solid #e88f12;
    border-right: 20px solid #c97e11;
    border-bottom-color: #e88f12;
    border-left-color: transparent;
    transform: rotate(-5deg);
  }

  &::after {
    left: auto;
    right: -70px;
    border-left: 20px solid #c97e11;
    border-right: 30px solid transparent;
    transform: rotate(5deg);
  }
`;
